import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import {
  ArrayInput,
  BooleanInput,
  FormDataConsumer,
  NumberInput,
  SelectInput,
  SimpleFormIterator,
  minLength,
  minValue,
  required,
  useDataProvider,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { BusinessModel, PaymentType } from '../../../models';
import { getChainId } from '../../../utils/utils';

export const RulesStep = () => {
  const [businessModel, setBusinessmodel] = useState(null);
  const companyId = useWatch({ name: 'companyId' });
  const chainId = useWatch({ name: 'chainId' }) || getChainId();
  const dataProvider = useDataProvider();

  useEffect(() => {
    if (!companyId || !chainId) return;

    dataProvider.getList(`companies/${companyId}/chains/${chainId}/business-model`, {})
      .then(({ data }) => {
        setBusinessmodel(data?.[0]?.businessModel ?? null);
      })
      .catch(() => {
        // Silenciosamente define como null se não encontrar
        setBusinessmodel(null);
      });
  }, [companyId, chainId, dataProvider]);

  return (
    <>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Regras do Contrato
      </Typography>

      <BooleanInput
        source="isForAggregated"
        label="Válido para agregados"
      />

      <BooleanInput
        source="isPriceLogEnabled"
        label="Compartilhar histórico de preço"
      />

      <FormDataConsumer>
        {({ formData }) =>
          formData.isForAggregated &&
          <BooleanInput
            source="isPriceLogForAggregateEnabled"
            label="Compartilhar histórico de preço com Agregado"
          />
        }
      </FormDataConsumer>

      <Typography variant="caption" sx={{ marginBottom: 2, display: 'block', marginTop: 3 }}>
        Este intervalo será considerado para definir se a transportadora atingiu a quantidade mínima de litros para ativar o acordo.
      </Typography>

      <NumberInput
        source="dealPeriod"
        label="Período de promoção (intervalo em dias)"
        validate={[minValue(1)]}
        sx={{ minWidth: 444 }}
      />

      {businessModel === BusinessModel.pumpxPro && (
        <>
          <Typography variant="h6" sx={{ marginBottom: 2, marginTop: 4 }}>
            Faturamento
          </Typography>

          <ArrayInput
            source="billingDay"
            label="Dias de Faturamento"
            sx={{ marginTop: 1, marginBottom: 1 }}
            validate={[required(), minLength(1)]}
          >
            <SimpleFormIterator
              disableReordering
              fullWidth
              sx={{
                '& .RaSimpleFormIterator-action': { visibility: 'visible' },
                '& .RaSimpleFormIterator-line': { paddingTop: 2 }
              }}
            >
              <NumberInput label="Dia" min={1} max={31} />
            </SimpleFormIterator>
          </ArrayInput>

          <NumberInput
            label="Prazo de Vencimento (em dias)"
            min={1}
            source="dueDate"
            validate={required()}
          />

          <SelectInput
            label="Forma de Pagamento"
            validate={required()}
            sx={{ width: 220 }}
            source="paymentType"
            choices={PaymentType.paymentTypeChoices}
          />
        </>
      )}
    </>
  );
};
